import * as React from 'react';
import { AdminMedicineModel } from "../../models/medicine";
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import * as Constants from '../../common/constants';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { FileModel } from "../../models/fileModel";
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { Dropdown } from 'primereact/dropdown';
import { DropdownModel } from '../../models/dropdownModel';
import { MedicineLeafletTypes, FileSystemType } from '../../common/enums';
import Translate from '../../common/functions/translate';

interface IProps {
  handleChange: any,
  medicine: AdminMedicineModel,
  addLeafletClick: any,
  removeLeafletClick: any,
  leafletTypeChange: any,
  selectedLangId: number
}

interface IState {
  validationMessage: string,
  leafletTypes: Array<DropdownModel>
}

class MedicineTabLeaflet extends React.Component<IProps, IState> {
  growl: any;
  currentFile: FileModel;
  refLefletFile: any;

  constructor(props: IProps) {
    super(props);

    let leafletTypes = HelperFunctions.enumToDropdownArray(MedicineLeafletTypes)
      .map(t => { return { value: t.value, label: Translate(t.label) } });

    this.state = {
      validationMessage: '',
      leafletTypes: leafletTypes
    };
  }

  onUpload(event) {
    this.growl.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
  }

  handleOnChange(event) {
    let file: File = event.target.files[0];
    let message = '';
    let fileExtension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

    this.currentFile = new FileModel();

    if (!fileExtension.match(/(doc|pdf|docx)$/i)) {
      message += 'Allowed file types are (doc, pdf, docx)';
    }

    if (file.size > Constants.MaxFileUploadSize) {
      message += 'File size is greater than ' + HelperFunctions.formatBytes(Constants.MaxFileUploadSize, 3) + '.<br />';
    }

    this.setState({
      validationMessage: message
    });

    if (!message) {
      this.currentFile.fileName = file.name;
      this.currentFile.fileType = fileExtension;
      this.currentFile.fileSizeInBytes = file.size;
      this.currentFile.medicineLeafletTypeId = 1;
      this.currentFile.langId = this.props.selectedLangId;

      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.currentFile.fileContent = reader.result;
        this.props.addLeafletClick(this.currentFile);
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  public render() {

    const { medicine } = this.props;

    return (
      <div className="p-grid p-fluid p-md-12">

        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}

        <div className="p-col-12 p-md-12" style={{ marginTop: "5px" }}>
          <input type="file" onChange={(e) => this.handleOnChange(e)} style={{ display: 'none' }} ref={(el) => this.refLefletFile = el} />
          <Button
            type="button"
            label="Add New"
            className="p-button-success"
            tooltip="Add new Leaflet"
            tooltipOptions={{ position: 'top' }}
            onClick={(e) => this.refLefletFile.click()}
            style={{ width: 'auto' }}
          />
          <span style={{ padding: '0 10px', fontSize: ".9em", fontStyle: 'italic' }}>
            Allowed file types are (doc, docx, pdf) and size up to {HelperFunctions.formatBytes(Constants.MaxFileUploadSize, 3)}.
          </span>
        </div>
        <div className="p-col-12 p-md-12">
          <DataTable
            value={medicine.leaflets.filter(r => r.langId == this.props.selectedLangId)}
          >
            <Column field="fileName" header="Name" body={(rowData, column) =>
              rowData.fileId ?
                <a href={`${Constants.apiUrl}/file/openFile/${rowData.fileId}/${FileSystemType.Leaflets}/${rowData.fileName}`} target='_blank'>{rowData.fileName}</a>
                : rowData.fileName
            } />
            <Column field="fileSizeInBytes" header="Size" body={(rowData, column) => HelperFunctions.formatBytes(rowData.fileSizeInBytes, 3)} />
            <Column field="fileSizeInBytes" header="Type"
              body={(rowData, column) =>
                <Dropdown
                  value={rowData.medicineLeafletTypeId ? rowData.medicineLeafletTypeId : 1}
                  options={this.state.leafletTypes}
                  onChange={(e) => this.props.leafletTypeChange(rowData, e.value)}
                  style={{ width: '100%' }}
                />

              } />
            <Column
              header="Actions"
              style={{ textAlign: "center", width: "8em" }}
              body={(rowData, column) =>
                <div>
                  <Button
                    type="button"
                    icon="pi pi-times-circle"
                    className="p-button-warning"
                    tooltip="Remove"
                    tooltipOptions={{ position: 'top' }}
                    onClick={() => this.props.removeLeafletClick(rowData)}
                  />
                </div>
              }
            />
          </DataTable>
        </div>
        {/* <div className="p-col-12 p-md-12">
          <Editor
            style={{ width: '100%', height: '500px' }}
            onTextChange={(e) => { this.props.handleChange('fullDescription', e.htmlValue) }}
            value={medicine && medicine.fullDescription ? medicine.fullDescription : ""}
          />
        </div> */}
      </div>
    )
  }
}

export default MedicineTabLeaflet;